<div class="login-container" [attr.data-testid]="'login-page'">
  <auth-header 
    (selectedLanguageGuid)="onSelectedLanguageGuid($event)"
    [attr.data-testid]="'login-header'"></auth-header>
  @if (forgotPwdStep === 'login') {
    <div class="login-form" [attr.data-testid]="'login-form'">
      <div class="header">
        <button
          pButton
          (click)="backButton()"
          class="back-button"
          severity="secondary"
          icon="ph ph-caret-left"
          aria-label="Back"
          [attr.data-testid]="'login-back-button'"></button>
        <span class="title-text" [attr.data-testid]="'login-title'">{{ 'doktar_app.auth.login.page_title' | translate }}</span>
        <span class="subtitle-text" [attr.data-testid]="'login-subtitle'">
          {{ 'doktar_app.auth.login.page_description' | translate }}
        </span>
      </div>

      @if (loginInputType === 'email') {
        <span class="login-email-input-label" [attr.data-testid]="'email-input-label'">
          {{ 'doktar_app.auth.login.email_label' | translate }}
        </span>

        <input
          pInputText
          class="login-email-input-text"
          type="email"
          name="email"
          [(ngModel)]="email"
          #emailInput="ngModel"
          [placeholder]="'doktar_app.common.email_placeholder' | translate"
          [email]="true"
          [attr.data-testid]="'login-email-input'" />
      } @else if (loginInputType === 'phone') {
        <span class="phone-input-label" [attr.data-testid]="'phone-input-label'">
          {{ 'doktar_app.common.phone_number_label' | translate }}
        </span>
        <div class="phone-number-input-container">
          <p-select
            [options]="countries"
            [(ngModel)]="selectedCountry"
            optionLabel="name"
            [filter]="true"
            filterBy="name,phoneCode"
            [showClear]="false"
            appendTo="body"
            class="country-selector"
            [attr.data-testid]="'country-selector'">
            <ng-template #selectedItem let-selectedOption>
              <div class="country-flag">
                <span class="flag-emoji view-only" [attr.title]="selectedOption.name">
                  {{ selectedOption.flagEmoji | unicodeToEmoji }}
                  {{ selectedOption.phoneCode }}
                </span>
              </div>
            </ng-template>
            <ng-template let-country #item>
              <div class="country-flag">
                <span class="flag-emoji" [attr.title]="country.name">{{ country.flagEmoji | unicodeToEmoji }}</span>
                <div>{{ country.phoneCode + ' ' + country.name }}</div>
              </div>
            </ng-template>
          </p-select>
          <p-inputNumber
            class="phone-number-input-mask"
            mask="999-999-99-99"
            [(ngModel)]="phoneNumber"
            [useGrouping]="false"
            [minlength]="6"
            [maxlength]="11"
            [attr.data-testid]="'login-phone-input'" />
        </div>
      }
      <span class="login-password-input-label" [attr.data-testid]="'password-input-label'">
        {{ 'doktar_app.common.password_label' | translate }}
      </span>

      <p-password
        class="login-password-input-container"
        [fluid]="true"
        inputStyleClass="login-password-input-text"
        name="password"
        [(ngModel)]="password"
        (ngModelChange)="onPasswordNgModelChange($event)"
        [minlength]="1"
        [maxLength]="passwordMaxLength"
        #passwordInput="ngModel"
        [placeholder]="'doktar_app.common.password_label' | translate"
        (onFocus)="passwordFocused = true"
        (onBlur)="passwordFocused = false"
        feedback="false"
        [ngClass]="{ 'not-valid': somethingWentWrong }"
        [toggleMask]="true"
        [attr.data-testid]="'login-password-input'">
        <ng-template pTemplate="showicon">
          <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
            'doktar_app.common.password_show_label' | translate
          }}</span>
        </ng-template>
        <ng-template pTemplate="hideicon">
          <span class="p-component p-iconwrapper p-password-toggle-mask-icon p-password-mask-icon mask-icon">{{
            'doktar_app.common.password_hide_label' | translate
          }}</span>
        </ng-template>
      </p-password>

      @if (somethingWentWrong) {
        <div class="error-container" [attr.data-testid]="'error-container'">
          <span class="error-text" [attr.data-testid]="'error-message'">
            {{ errorMessage }}
          </span>
        </div>
      }

      <p-button 
        class="forgot-password-button" 
        (onClick)="forgotPwdDirection()" 
        variant="text"
        [attr.data-testid]="'forgot-password-button'">
        <span>
          {{ 'doktar_app.auth.login.forgat_password' | translate }}
        </span>
      </p-button>

      <div class="login-buttons" [attr.data-testid]="'login-buttons-container'">
        <dk-button
          class="login-button"
          [size]="'xlarge'"
          [label]="'doktar_app.auth.login.page_title' | translate"
          [disabled]="(loginInputType === 'phone' ? !phoneNumber : !email) || !password"
          [loading]="loggingIn"
          (onClick)="login(undefined, undefined, undefined)"
          [attr.data-testid]="'login-submit-button'"></dk-button>
        <dk-button
          class="already-in-button"
          [size]="'xlarge'"
          (onClick)="goToRegister()"
          severity="contrast"
          [text]="true"
          [attr.data-testid]="'register-link-button'">
          <span
            >{{ 'doktar_app.auth.login.new_to_doktar_label' | translate }}
            <b>{{ 'doktar_app.auth.login.register_lbl' | translate }}</b>
          </span>
        </dk-button>
      </div>
      <div class="sso-container" [attr.data-testid]="'sso-container'">
        <span class="sso-info-text" [attr.data-testid]="'sso-info-text'">{{ 'doktar_app.auth.register.sso_information' | translate }}</span>
        <div class="sso-button-container">
          <p-button 
            severity="secondary" 
            aria-label="Keypad" 
            (click)="changeInputType()"
            [attr.data-testid]="'input-type-toggle'">
            <ng-template pTemplate="icon">
              <dk-numpad-icon [hidden]="loginInputType === 'phone'"></dk-numpad-icon>
              <dk-mail-icon [hidden]="loginInputType === 'email'"></dk-mail-icon>
            </ng-template>
          </p-button>
          <p-button 
            severity="secondary" 
            aria-label="Apple SSO" 
            (click)="onSSOButtonClick(externalProviderTypes.Apple)"
            [attr.data-testid]="'sso-apple-button'">
            <ng-template pTemplate="icon">
              <dk-apple-icon></dk-apple-icon>
            </ng-template>
          </p-button>
          <p-button
            severity="secondary"
            aria-label="Google SSO"
            (click)="onSSOButtonClick(externalProviderTypes.Google)"
            [attr.data-testid]="'sso-google-button'">
            <ng-template pTemplate="icon">
              <dk-google-icon></dk-google-icon>
            </ng-template>
          </p-button>
          @if (false) {
            <p-button
              severity="secondary"
              aria-label="MS SSO"
              (click)="onSSOButtonClick(externalProviderTypes.Microsoft)"
              [attr.data-testid]="'sso-microsoft-button'">
              <ng-template pTemplate="icon">
                <dk-microsoft-icon></dk-microsoft-icon>
              </ng-template>
            </p-button>
            <p-button 
              severity="secondary" 
              aria-label="FB SSO" 
              (click)="onSSOButtonClick(externalProviderTypes.Facebook)"
              [attr.data-testid]="'sso-facebook-button'">
              <ng-template pTemplate="icon">
                <dk-facebook-icon></dk-facebook-icon>
              </ng-template>
            </p-button>
          }
        </div>
      </div>
    </div>
  } @else if (forgotPwdStep === 'forgot-pwd') {
    <div class="forgot-pwd-container" [attr.data-testid]="'forgot-pwd-step'">
      <auth-forgot-pwd
        (steperChange)="onSteperChange($event)"
        (verifyOtpInfo)="onVerifyOtpInfo($event)"
        [loginInputType]="loginInputType"></auth-forgot-pwd>
    </div>
  } @else if (forgotPwdStep === 'verify-otp') {
    <div class="verify-otp-container" [attr.data-testid]="'verify-otp-step'">
      <auth-verify-otp
        (steperChange)="onSteperChange($event)"
        [verifyOtpInfo]="verifyOtpInfo"
        [loginInputType]="loginInputType"></auth-verify-otp>
    </div>
  } @else if (forgotPwdStep === 'change-pwd') {
    <div class="change-pwd-container" [attr.data-testid]="'change-pwd-step'">
      <auth-change-pwd (steperChange)="onSteperChange($event)"></auth-change-pwd>
    </div>
  }
</div>

<app-confirm-otp [attr.data-testid]="'otp-dialog'"></app-confirm-otp>
